export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11017.0cdabbd3.jpg";